import { apiPrime } from 'utils/bolt/apiPrime';
import { getShowtimesData } from 'utils/bolt/showtimes';
import { CANCELLED, TICK, CLOSE, SOLD_OUT } from 'helpers/constants';
import Store from 'store/store';


export const getUserTickets = async (userId) => {
	const earlyAccessWindow = Store.get()?.showtimes?.earlyAccessWindow ? 'true' : 'false';
	const showtimesAppData = getShowtimesData();
	const movieId = showtimesAppData.movieId || '';
	const ticketsResponse = await apiPrime({
		method: 'get',
		path: '/get-user-tickets',
		query: {
			user_id: userId,
			movie_id: movieId,
			early_access_window: earlyAccessWindow
		}
	});

	if (ticketsResponse.result !== 'ok') {
		console.error('Error getting tickets for user');
		return;
	}

	return ticketsResponse.response?.data;
};

export const bookTickets = async (screening, customerData, numTickets, selectedTheater, earlyAccessCode) => {
	Store.emit('SHOW_FULL_LOADER', true);

	try {
		const response = await apiPrime({
			method: 'post',
			path: '/book-tickets',
			body: {
				screeningId: screening?.id,
				userId: customerData?.id,
				userFullName: customerData?.name,
				userEmail: customerData?.email,
				earlyAccessCode,
				quantity: numTickets
			}
		});

		if (response.result !== 'ok') {
			console.error('Error booking tickets');
			Store.emit('SHOW_FULL_LOADER', false);
			if (response.result === SOLD_OUT) {
				return SOLD_OUT;
			}
			return;
		}

		const tickets = await getUserTickets(customerData.id);
		Store.emit('RETRIEVED_USER_TICKETS', tickets);
		Store.emit('SHOW_FULL_LOADER', false);
		Store.emit('TRACK_BOOK_TICKETS', ({ theaterName: selectedTheater?.name, numTickets }));
		return tickets;
	} catch (e) {
		Store.emit('SHOW_FULL_LOADER', false);
		console.error('Error booking tickets -', e);
		return;
	}
};

export const cancelTickets = async (quantity) => {
	Store.emit('SHOW_FULL_LOADER', true);
	const store = Store.get() || {};
	const copy = store.appData?.copy?.baseCopy || {};
	const customerData = store.showtimes?.customer || {};
	const currentTickets = customerData.tickets;

	if (!currentTickets) return;

	let ticketIds;
	if (quantity < 2) {
		ticketIds = [currentTickets[0].id];
	} else {
		ticketIds = currentTickets.map(ticket => ticket.id);
	}

	try {
		const response = await apiPrime({
			method: 'post',
			path: '/cancel-tickets',
			body: {
				ticketIds
			}
		});
		if (response.result !== 'ok') {
			console.error('Error cancelling tickets');
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}
		const tickets = await getUserTickets(customerData.id);
		Store.emit('RETRIEVED_USER_TICKETS', tickets);
		Store.emit('SHOW_FULL_LOADER', false);
		Store.emit('SHOW_INFO_SCREEN', {
			type: CANCELLED,
			ticketIcon: TICK,
			message: quantity > 1 ? copy.$TICKETS_CANCELLED : copy.$TICKET_CANCELLED,
			buttons: [{ text: copy.$BACK_TO_LISTINGS, action: CLOSE }]
		});
		Store.emit('TRACK_CANCEL_TICKETS', ({ theaterName: currentTickets?.[0]?.theater?.name, numTickets: quantity }));
		return tickets;
	} catch (e) {
		Store.emit('SHOW_FULL_LOADER', false);
		console.error('Error cancelling tickets -', e);
		return;
	}
};